<div class="toaster-container">
    @for (item of listAlerts; track $index) {
        <ngb-toast (hidden)="removeAlert($index)" class="custom-toaster toaster-{{ item.type }} mt-2" [header]="item.header" [delay]="item.delay || 5000">
            {{ item.message }}
        </ngb-toast>
    }
</div>

